import Smartphones from 'Events/EventPay/views/EventPayView/containers/Smartphones'
import Tablets from 'Events/EventPay/views/EventPayView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const EventPayView = getCurrentDeviceView(Smartphones, Tablets)

export default EventPayView
